import { useIntl } from 'react-intl';

import { CampaignType } from 'apis/restaurant-api/merchant-admin/campaigns/types';
import { FeatureType } from 'common/types';
import {
  ExperienceEntityType,
  NavigationAnnouncement,
  NavigationKey,
  useExperienceModuleContext,
} from 'modules/experience-core';

import useCampaignTypesPermittedToEdit from './useCampaignTypesPermittedToEdit';

export const useEoDCampaignsNavigationAnnouncement = (): NavigationAnnouncement<'end-of-day-campaigns'>[] => {
  const { formatMessage } = useIntl();

  const {
    experienceEntity: { experienceEntityId, experienceEntityType, experienceEntityObject },
    city,
    country,
  } = useExperienceModuleContext();

  const { isLoading, campaignTypesPermittedToEdit } = useCampaignTypesPermittedToEdit({
    feature: experienceEntityType !== ExperienceEntityType.BRAND ? (experienceEntityType as FeatureType) : undefined,
    featureId: experienceEntityId,
    city: experienceEntityType === ExperienceEntityType.VENUE ? city : undefined,
    entityCountry: experienceEntityType === ExperienceEntityType.VENUE ? country : undefined,
    productLine: experienceEntityType === ExperienceEntityType.VENUE ? experienceEntityObject.product_line : undefined,
  });

  const isDisabled = !campaignTypesPermittedToEdit.includes(CampaignType.END_OF_DAY);

  if (isLoading || isDisabled) {
    return [];
  }

  return [
    {
      id: 'end-of-day-campaigns',
      navigationKey: NavigationKey.CAMPAIGNS,
      text: formatMessage({ id: 'navigation.tooltips.campaigns.end-of-day' }),
      tag: formatMessage({ id: 'navigation.new' }),
    },
  ];
};
